import { configs } from '../../app/app-configs';
import { Pagination } from '../../model/pagination';

export interface BiometricDevice {
    id: number;
    businessId: number;
    serialNumber: string;
    deviceName: string;
    model: string;
    enabled: boolean;
    lastSeenAt: Date;
    createdTime: Date;
    updatedTime: Date;
}

export interface BiometricDeviceRequest {
    id?: number;
    serialNumber: string;
    deviceName: string;
    model: string;
    enabled: boolean;
}

export interface BiometricDeviceUser {
    id: number;
    biometricDeviceId: number;
    devicePin: string;
    name: string;
    memberId: number;
    businessUserId: number;
    enabled: boolean;
    createdTime: Date;
    updatedTime: Date;
}

export interface BiometricDeviceUserRequest {
    id?: number;
    biometricDeviceId: number;
    devicePin: string;
    name: string;
    memberId: number;
    businessUserId: number;
    enabled: boolean;
}

export interface BiometricDeviceUserSearchCriteria {
    pagination: Pagination;
    name: string;
    deviceId?: number;
}

export const getDefaultBiometricDeviceUserSearchCriteria = (
    deviceId?: number,
): BiometricDeviceUserSearchCriteria => ({
    pagination: { page: 0, size: configs.PAGE_SIZE },
    name: '',
    deviceId: deviceId,
});

export interface BiometricTransaction {
    id: number;
    biometricDeviceId: number;
    devicePin: string;
    punchTime: string;
    verifyType: number;
    status: number;
    workCode: number;
    rawRecord: string;
    receivedAt: string;
    processingStatus: string;
    processingError: string;
    processedAt: string;
}

export interface BiometricTransactionSearchCriteria {
    pagination: Pagination;
    deviceId?: number;
}

export const getDefaultBiometricTransactionSearchCriteria =
    (): BiometricTransactionSearchCriteria => ({
        pagination: { page: 0, size: configs.PAGE_SIZE },
    });
